// extracted by mini-css-extract-plugin
export default {"actionColumn":"ProfilesTable__actionColumn-qXCMT"};